<mat-card>
  <mat-card-header>
    <h1>Account security</h1>
  </mat-card-header>

  <mat-card-content>
    <mat-tab-group>
      <mat-tab label="Login credentials">
        <p>This is how you currently login to risr/apply. Make sure you can always access your account by keeping this information up to date.</p>

        <div class="list-item" *ngFor="let loginCredential of loginCredentials;">
          <div>
            <p>{{ readableName[loginCredential.type] }}</p>
            <p><strong>{{ loginCredential.username }}</strong></p>
            <p class="label label-warning" *ngIf="loginCredential.passwordNotSet">
              A welcome email will be sent to guide the user through the setup process
            </p>
          </div>
          <ul class="list-inline list-unstyled">
            <li *ngIf="canAccessTwoFactorAuth(loginCredential.type)">
              <a mat-flat-button color="accent" [routerLink]="[loginCredential.username, 'mfas']" [attr.aria-label]="'Two factor authentication for ' + loginCredential.username">
                Two Factor Authentication
              </a>
            </li>
            <li *ngIf="canUpdateUsername(loginCredential.type)"><button mat-flat-button color="accent" (click)="updateUsername(loginCredential)" [attr.aria-label]="'Edit username for ' + loginCredential.username">Edit username</button></li>
            <li *ngIf="canUpdateSSOID(loginCredential.type)"><button mat-flat-button color="accent" (click)="updateUsername(loginCredential)" [attr.aria-label]="'Edit SSO ID for ' + loginCredential.username">Edit SSO ID</button></li>
            <li *ngIf="canSendPasswordEmail(loginCredential.type)"><button mat-flat-button color="accent" (click)="sendPasswordEmail(loginCredential)" [attr.aria-label]="'Send password reset email for ' + loginCredential.username">Send password reset email</button></li>
            <li *ngIf="canUpdatePassword(loginCredential.type)"><button mat-flat-button color="accent" (click)="updatePassword(loginCredential)" [attr.aria-label]="'Change password for ' + loginCredential.username">Change password</button></li>
            <li *ngIf="canDelete()"><button mat-flat-button color="warn" (click)="deleteCredential(loginCredential)" [attr.aria-label]="'Remove ' + loginCredential.username">Remove</button></li>
          </ul>
        </div>

        <div class="mt-4 mb-4">
          <ul class="list-inline list-unstyled">
            <li *ngFor="let type of allowedAccountTypes">
              <button class="mr-2" mat-flat-button color="primary" (click)="addLoginCredential(type)" *ngIf="canCreateCredential(type)">Add {{ readableName[type] }} Credential</button>
            </li>
          </ul>
        </div>
      </mat-tab>

      <mat-tab label="API keys" *ngIf="canAccessAPIKeys()">
        <div *ngIf="newlyCreatedAPICredential" class="box box-warn">
          <p>
            <strong>Warning!</strong> Make sure you copy the API credentials below. You won't be able to see them again!
          </p>
        </div>

        <div *ngIf="newlyCreatedAPICredential" class="copy-text__container">
          <ul class="list-unstyled copy-text__text">
            <li>public_key: {{newlyCreatedAPICredential.public_key}}</li>
            <li>secret_key: {{newlyCreatedAPICredential.secret_key}}</li>
          </ul>
          <button mat-stroked-button (click)="copyToClipboard()">Copy</button>
        </div>
        <div class="list-item" *ngFor="let apiCredential of apiCredentials;">
          <div>
            <p>{{ readableName[apiCredential.type] }}</p>
            <p><strong>{{ apiCredential.public_key }}</strong></p>
          </div>
          <div>
            <button mat-flat-button color="warn" class="btn btn-sm btn-danger" (click)="deleteCredential(apiCredential)" [attr.aria-label]="'Remove ' + apiCredential.public_key">Remove</button>
          </div>
        </div>

        <div class="mt-4 mb-4">
          <p><button mat-flat-button color="primary" (click)="createApiCredential()" *ngIf="canCreateCredential(CredentialTypes.API)">Add API credential</button></p>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
